(function () {
  const hiddenRoleImgSelector = 'svg[role="img"][aria-hidden="true"]';

  const normalizeHiddenRoleImages = (root) => {
    if (!root || root.nodeType !== Node.ELEMENT_NODE) return;

    if (root.matches(hiddenRoleImgSelector)) {
      root.removeAttribute('role');
    }

    root.querySelectorAll?.(hiddenRoleImgSelector).forEach((element) => {
      element.removeAttribute('role');
    });
  };

  const run = () => {
    normalizeHiddenRoleImages(document.documentElement);

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes') {
          normalizeHiddenRoleImages(mutation.target);
          return;
        }

        mutation.addedNodes.forEach(normalizeHiddenRoleImages);
      });
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['role', 'aria-hidden'],
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }
})();
